<template>
  <div class="Kanit BGwhite">
    <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <!-- <v-icon @click="backlink()">navigate_before</v-icon> -->
                  <v-btn icon flat @click="backlink()"><v-icon>navigate_before</v-icon></v-btn>
                  <h2 style="display: inline-block;margin-left: 1em;">{{name}} </h2>
                  <div style="display: flex; margin-top: 30px;">
                    <div class="cardticket" @click="gotoinfo()">
                      <div class="cardticket-header">
                        <v-img class="image" max-height="150" max-width="200" :src="profilepicture" v-if="profilepicture != ''"></v-img>
                        <v-img class="image" src="../../../static/icon/bot-bubble1.svg" max-height="150" max-width="200" v-else></v-img>
                        <h3 class="header-text" style="margin-top: 5px;">ข้อมูลบอท</h3>
                      </div>
                      <div class="cardticket-body">
                        <span class="text-body">&nbsp;&nbsp;&nbsp;&nbsp;แสดงรายละเอียดของบอท, QR code, ภาพประจำตัวบอท และอื่นๆ</span>
                      </div>
                    </div>
                    <div class="cardticket" @click="gotomsg_reply()">
                      <div class="cardticket-header">
                        <v-img class="image" src="../../../static/image_v2/bot_automessage.jpg" max-height="150" max-width="200"></v-img>
                        <h3 class="header-text" style="margin-top: 5px;">ข้อความตอบกลับ อัตโนมัติ</h3>
                      </div>
                      <div class="cardticket-body">
                        <span class="text-body">&nbsp;&nbsp;&nbsp;&nbsp;แสดงรายละเอียด เพิ่ม และ แก้ไข ข้อความตอบกลับ อัตโนมัติ</span>
                      </div>
                    </div>
                    <div class="cardticket" @click="gotorichmenu()">
                      <div class="cardticket-header">
                        <v-img class="image" src="../../../static/templateBottomMenu/BM1.png" max-height="150" max-width="200" style="border: 1px solid gray;"></v-img>
                        <h3 class="header-text" style="margin-top: 5px;">เมนูในแถบแชท</h3>
                      </div>
                      <div class="cardticket-body">
                        <span class="text-body">&nbsp;&nbsp;&nbsp;&nbsp;สร้างแถบเมนูด้านล่าง เพื่อการใช้งานที่สะดวกของผู้ใช้งาน</span>
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <br>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
// import $ from 'jquery'

Vue.component(VueQrcode.name, VueQrcode)
export default {
  data: () => ({
    development: '',
    webbackend: '',
    profilepicture: '',
    botid: '',
    name: '',
    token: '',
    windowWidth: '',
    tokenbot: ''
  }),
  methods: {
    alert () {
      alert('jam')
    },
    gotorichmenu () {
      this.$router.push('/develop/bottommenu/list/' + this.tokenbot)
    },
    gotoinfo () {
      this.$router.push('/develop/editbot/' + this.botid + '/' + this.tokenbot)
    },
    gotomsg_reply () {
      this.$router.push('/develop/message_reply/' + this.botid + '/' + this.tokenbot)
    },
    backlink () {
      this.$router.push('/develop/homepage')
    },
    getSerchuser () {
      this.botid = this.$route.params.id
      this.tokenbot = this.$route.params.tokenbot
      this.token = localStorage.getItem('tokenuser')
      this.$http.post(process.env.APImanage + '/searchuser2', {tokenuser: this.token, type: 'bot', key: this.botid}).then((response) => {
        if (response.body['status'] === 'success') {
          // this.tokenbot = response.body.listuser[0].user.tokenuser
          this.profilepicture = response.body.listuser[0].user.profilepicture
          this.name = response.body.listuser[0].user.name
        }
      }, (response) => {})
    }
  },
  computed: {
    ...mapState({
      botinfo: 'botinfo'
    })
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/dev_manage/' + this.botid)
      }
    },
    botinfo () {
      this.getSerchuser()
    }
  },
  created () {
    this.webbackend = process.env.API
    this.development = '-'
    this.getSerchuser()
  }
}
</script>
<style type="text/css" scoped>

.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}

.edit {
  font-weight: 100;
}


.img {
  display: block;
  max-width: 230px;
  max-height: 95px;
  width: auto;
  height: auto;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

/*.v-card .header-text {
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  position: relative;
  color: white !important;
}

.v-card:hover .header-text {
  margin: 40px 0 20px;
  padding-left: 20px;
  line-height: 1.3;
  font-weight: bold;
  font-size: 16px;
  color: white !important;
}

.v-card .header-text::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: 0;
  height: 32px;
  border-left: 4px solid #f0c56a;
}
*/
.Setting {
  margin-bottom: 2vh;
}



.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.BGwhite {
  background-color: white !important;
}


>>>.v-card {
  font-size: small;
  background-color: #181f29 !important;
}

>>>.v-card:hover {
  opacity: 1;
  /* background-color: #2562af; */
  background-color: #2562af !important;
}

>>>.v-card .text {
  color: white;
  font-size: 14px;
  top: 20px;
  padding-left: 10%;
}


.v-card:hover .text {
  color: white;
  font-size: 14px;
}



.image {
  /*opacity: 0.8;*/
  border-radius: 10px;
  object-fit: cover;
  object-position: 50% 0;
}

.v-card:hover .image {
  opacity: 1;
  width: 250px;
}

.container.grid-list-md .layout .flex {
  padding: 4px;
  padding-left: 8px;
}


.cardticket-body .text {
  white-space: inherit;
}

.cardticket {
  width: 224px;
  border-radius: 10px;
  margin: 10px;
  background: white;
  overflow: hidden;
  cursor: pointer;
}

.cardticket-header .header-text {
  color: #2463af;
}

.cardticket:hover .cardticket-header .header-text {
  color: white;
}

.cardticket:hover {
  background: #2463af;
  color: white;
}

.cardticket:hover .cardticket-header {
  border-bottom: 2px dotted white;
}

.cardticket-header {
  height: 200px;
  border: 2px solid #2463af;
  border-bottom: 2px dotted #2463af;
  border-radius: 10px 10px 0 0;
  position: relative;
  text-align: center;
  padding: 10px;
}

.cardticket-header:before,
.cardticket-header:after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 100%;
  bottom: -12px;
  border: 2px solid #2463af;
  box-sizing: border-box;
}

.cardticket-header:before {
  left: -20px;
}

.cardticket-header:after {
  right: -20px;
}

.cardticket-body {
  height: 80px;
  border: 2px solid #2463af;
  border-top: none;
  border-radius: 0 0 10px 10px;
  padding: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/managebot/firstpage.vue